import React from 'react';
import {
  OrganizationBiztraTable,
  OrganizationBiztraTh,
  OrganizationBiztraTr,
  OrganizationBiztraTd
} from '@this/src/components/expenses/organization/organization.style';

interface Props {
  status: any;
}

export default class BulkUpsertActionAccountTypes extends React.Component<Props> {
  getStatusClass = (bulkAction: any): string =>
    bulkAction.isSuccess() ? 'green' : bulkAction.isFail() ? 'red' : 'gray';

  render() {
    const { status } = this.props;
    return (
      <OrganizationBiztraTable>
        <thead>
          <tr>
            <OrganizationBiztraTh>勘定科目名</OrganizationBiztraTh>
            <OrganizationBiztraTh>処理結果</OrganizationBiztraTh>
          </tr>
        </thead>
        <tbody>
          {status.actionExpensesAccountTypes.map((expenses_account_type: any, i: number) => (
            <OrganizationBiztraTr key={i} className={i % 2 === 1 ? 'even' : 'odd'}>
              <OrganizationBiztraTd>{expenses_account_type.code}</OrganizationBiztraTd>
              <OrganizationBiztraTd className={`${this.getStatusClass(expenses_account_type)}`}>
                {expenses_account_type.statusMessage()}
              </OrganizationBiztraTd>
            </OrganizationBiztraTr>
          ))}
        </tbody>
      </OrganizationBiztraTable>
    );
  }
}
